import React from 'react';

import Toast from '../../../components/Toast/Toast';

/**
 * @returns {?JSX.Element} ErrorToast or null
 */
export function ErrorToast({ message, showIcon = true }) {
  if (!message) {
    return null;
  }

  return <Toast error={decodeURIComponent(message)} icon={showIcon} />;
}
